"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_ITEMS_REPLACEMENT_DETAILS = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.SET_ITEMS_REPLACEMENT_DETAILS = 'SET_ITEMS_REPLACEMENT_DETAILS';
